import type { ResolvedTheme } from "@/src/contexts/ThemeContext";

// Valeurs concrètes des tokens de src/css/index.css pour les libs qui ne lisent pas les variables CSS (MUI, Stripe).
export const THEME_TOKENS = {
  light: {
    primary: "#01b9cc",
    destructive: "#dc2626",
    background: "#f3f4f6",
    card: "#ffffff",
    foreground: "#232730",
    mutedForeground: "#8b8f96",
  },
  dark: {
    primary: "#22d3ee",
    destructive: "#f87171",
    background: "#1e2024",
    card: "#2a2c31",
    foreground: "#f9fafb",
    mutedForeground: "#b2b5bc",
  },
} as const satisfies Record<ResolvedTheme, Record<string, string>>;
